'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var AFFILIATE_QUERY = 'affiliate:query';

exports.AFFILIATE_QUERY = AFFILIATE_QUERY;
